import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import StoreCta from '../components/StoreCta';

export default function Landing() {
  const { user, loading } = useAuth();
  const { t } = useLanguage();

  return (
    <div className="grid two-col">
      <div className="card" style={{ position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: -80, right: -60, width: 200, height: 200, borderRadius: '50%', background: 'rgba(249,115,22,0.22)' }} />
        <p className="tag">APHEL SOCIAL FITNESS</p>
        <h1 style={{ fontFamily: '"Playfair Display", serif', fontSize: 42, margin: '16px 0 8px' }}>
          {t('landing.heroTitle')}
        </h1>
        <p className="section-subtitle">{t('landing.heroDesc')}</p>
        <div style={{ display: 'flex', gap: 12, marginTop: 24, flexWrap: 'wrap' }}>
          {loading ? null : user ? (
            <Link className="btn btn-primary" to="/feed">
              {t('actions.goFeed')}
            </Link>
          ) : (
            <>
              <Link className="btn btn-primary" to="/kayit">
                {t('actions.startNow')}
              </Link>
              <Link className="btn btn-ghost" to="/giris">
                {t('actions.login')}
              </Link>
            </>
          )}
        </div>
      </div>

      <div className="grid">
        <div className="card">
          <h3 className="section-title">{t('landing.featureFeedTitle')}</h3>
          <p className="section-subtitle">{t('landing.featureFeedDesc')}</p>
        </div>
        <div className="card">
          <h3 className="section-title">{t('landing.featureChatTitle')}</h3>
          <p className="section-subtitle">{t('landing.featureChatDesc')}</p>
        </div>
        <div className="card">
          <h3 className="section-title">{t('landing.featurePlanTitle')}</h3>
          <p className="section-subtitle">{t('landing.featurePlanDesc')}</p>
        </div>
        <StoreCta />
      </div>
    </div>
  );
}
